export enum FieldDefValidations {
    TEXT = 'TEXT',
    COMBOBOX = 'COMBOBOX',
    CHECKBOX = 'CHECKBOX',
    CHECKLIST = 'CHECKLIST',
    CHECKLISTEDIT = 'CHECKLISTEDIT',
    DURATION = 'DURATION',
    NUMBER = 'NUMBER',
    DATE = 'DATE',
    TIME = 'TIME',
    COLLECTION = 'COLLECTION',
    FORM = 'FORM',
    SPECIAL = 'SPECIAL',
    TREE = 'TREE',
    DUAL = 'DUAL',
    TABLE = 'TABLE',
    MOSDATETIME = 'MOSDATETIME',
    MOSDURATION = 'MOSDURATION',
    MOSAUTOMATION = 'MOSAUTOMATION',
    MOSAUTOMATIONDURATION = 'MOSAUTOMATIONDURATION',
    STAFFIDLIST = 'STAFFIDLIST',
    LOOKUPLIST = 'LOOKUPLIST',
    ADDRESS = 'ADDRESS',
    COST = 'COST',
    LOCATIONLIST = 'LOCATIONLIST',
    VIEWSTATEORDER = 'VIEWSTATEORDER',
    DATETIMERANGE = 'DATETIMERANGE',
    WEBHOOKSIDLIST = 'WEBHOOKSIDLIST',
    SELECT = 'SELECT',
    PSTPUBLICATIONLISTTIME = 'PSTPUBLICATIONLISTTIME',
}

export enum Directions {
    Left = 'left',
    Right = 'right',
    Up = 'up',
    Down = 'down',
}

export enum TimeUnits {
    Hours = 'hours',
    Minutes = 'minutes',
    Seconds = 'seconds',
}

export enum StoryOutputType {
    BROADCAST = 'Broadcast',
    WEB = 'Web',
    SOCIAL = 'Social',
}

export enum CustomMatIcon {
    TWITTER = 'twitter',
    AP_LOGO = 'ap_logo',
    TEMPLATE_SELECTION_ONE = 'template_selection_1',
    TEMPLATE_SELECTION_TWO = 'template_selection_2',
    TEMPLATE_SELECTION_THREE = 'template_selection_3',
    TEMPLATE_SELECTION_FOUR = 'template_selection_4',
    TEMPLATE_SELECTION_FIVE = 'template_selection_5',
    HOME = 'home',
}
export enum Feeds {
    APFEED = 'APFEED',
    FTPFEED = 'FTPFEED',
    RSSFEED = 'RSSFEED',
    TWITTERFEED = 'TWITTERFEED',
}

export enum ViewFeedTypes {
    AP = 'AP',
    FTP = 'FTP',
    RSS = 'RSS',
    TWITTER = 'TWITTER',
}

export enum SearchType {
    SAVED = 'saved',
    SEARCH = 'search',
}

export enum CardViewType {
    LARGE = 'large',
    SMALL = 'small',
    MEDIUM = 'medium',
}

export enum NodeId {
    TOPICS = 'topics',
    ASSIGNMENTS = 'assignments',
    STORIES = 'stories',
    RUNDOWNS = 'rundowns',
}
export enum EditorActions {
    SAVE = 'save',
}

// Rich Text Editor Menu
export enum EditorMenuCommandType {
    EDITOR = 'editor',
    STORY = 'story',
}

export enum EditorMenuId {
    STORY = 'story',
    VIEW = 'view',
    EDIT = 'edit',
    INSERT = 'insert',
    FORMAT = 'format',
    TEXT = 'text',
    DIVIDER = 'divider',
    DELETE = 'delete',
    // Story section
    STORY_NEW = 'story_new',
    STORY_NEW_TEMPLATE = 'story_new_template',
    STORY_GENERATE = 'story_generate',
    STORY_GENERATE_PROMPT = 'story_generate_prompt',
    STORY_DUPLICATE = 'story_duplicate',
    STORY_COPY = 'story_copy',
    STORY_COPY_TO_CLIPBOARD = 'story_copy_to_clipboard',
    STORY_COPY_TO_STORY_LINK = 'story_copy_to_story_link',
    STORY_SAVE = 'story_save',
    STORY_SAVE_AS_TEMPLATE = 'story_save_as_template',
    STORY_RENAME = 'story_rename',
    STORY_MOVE = 'story_move',
    //Edit section
    STORY_EDIT = 'story_edit',
    STORY_UNDO = 'story_undo',
    STORY_REDO = 'story_redo',
    STORY_CUT = 'story_cut',
    STORY_PASTE = 'story_paste',
    STORY_SELECT_ALL = 'story_select_all',
    FIND_AND_REPLACE = 'find_and_replace',
    STORY_REMOVE = 'story_remove',
    //VIew section
    LIST_VIEW = 'list_view',
    SPLIT_VIEW = 'split_view',
    EXPAND_ALL_ELEMENTS = 'expand_all_elements',
    FULLSCREEN = 'fullscreen',
    //Insert section
    STORY_VIEW = 'story_view',
    STORY_INSERT = 'story_insert',
    STORY_FORMAT = 'story_format',
    STORY_PROPERTIES = 'story_properties',
    STORY_TOOLS = 'story_tools',
    VOSOT = 'vosot',
    //Format section
    BOLD = 'bold',
    ITALIC = 'italic',
    UNDERLINE = 'underline',
    STRIKETHROUGH = 'strikethrough',
    SUBSCRIPT = 'subscript',
    SUPERSCRIPT = 'superscript',
    ALIGN_LEFT = 'left',
    ALIGN_CENTER = 'center',
    ALIGN_RIGHT = 'right',
    ALIGN_JUSTIFY = 'justify',
    FONT_SIZE = 'font_size',
    FONT_SIZE_INCREASE = 'font_size_increase',
    FONT_SIZE_DECREASE = 'font_size_decrease',
    CAPITALIZATION = 'capitalization',
    UPPERCASE = 'uppercase',
    LOWERCASE = 'lowercase',
    TITLECASE = 'titlecase',
    ALIGN_AND_INDENT = 'align_and_indent',
    INDENT = 'indent',
    OUTDENT = 'outdent',
    PARAGRAPH_STYLES = 'paragraph_styles',
    HEADLINE1 = 'H1',
    HEADLINE2 = 'H2',
    HEADLINE3 = 'H3',
    CLEAR_FORMATTING = 'clear_formatting',
    //Properties
    PROPERTIES = 'properties',
}
// EoF Rich Text Editor Menu
